<template>
  <vs-popup class="checkout-popup-promotion" title="Redemtion Detail" :active.sync="popupConfigRedemtion.isOpen">
     <div class="mt-6 background-with-theme" style="max-height: calc(100vh - 300px); overflow-y: auto; background: #fafafa; padding: 20px">
      <vx-card class="mb-5 overflow-hidden md:p-0 p-5" v-for="(redem, index) in redemtionData" :key="index" :class="{'is-selected': redem.checked}">
        <div class="vs-component con-vs-checkbox vs-checkbox-primary vs-checkbox-default p-6">
          <input type="checkbox" class="vs-checkbox--input" :id="redem.id" v-model="redem.checked" @click="addRedemtion(redem)">
          <span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
            <span class="vs-checkbox--check"><i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">check</i></span>
          </span>
          <span class="con-slot-label">
            <div class="title pl-4">{{redem.content}}</div>
            </span>
        </div>
      </vx-card>
    </div>
  </vs-popup>
</template>

<script>
export default {
    name: "vs-popup-redemtion",
    props:{
      popupConfigRedemtion:{
        type: Object,
        required: true
      },
      redemtionData: {
        type: Array,
        required: true
      }
    },
    data(){
      return {
      }
    },
    methods: {
      changeStatusCheckBox(item) {
        this.$store.dispatch('checkin/CHANGE_STATUS_REDEMPTION', item);
      },
      addRedemtion(redem){
        this.changeStatusCheckBox(redem);
        this.$emit("AddRedemtion" , redem);
      }
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
.con-vs-popup
{
    &.checkout-popup-promotion {
      // z-index: 999999;
      //   .vs-popup {
      //   }
      .vx-card__body {
        padding: 0 !important;
      }
      .is-selected {
          -webkit-transform: translate(0)!important;
          transform: translate(0)!important;
          background: rgba($primary,.05)!important;
      }

      .is-selected {
          color: rgba($primary,1);
          -webkit-box-shadow: 0 0 1px 0 rgba($primary,1)!important;
          box-shadow: 0 0 1px 0 rgba($primary,1)!important;
      }
    }
}
.theme-dark {
  .background-with-theme {
    background: transparent !important;
  }
}
</style>
